module.exports = __webpack_public_path__ + "img/plan-standard.391b688.png";